import {RolesArcgisActions, RolesArcgisActionTypes} from './roles-arcgis.actions';
import {initialState, rolesArcgisAdapter, RolesArcgisState} from './roles-arcgis.state';

export function rolesArcgisReducer(
  state = initialState,
  action: RolesArcgisActions
): RolesArcgisState {
  switch (action.type) {
    // load
    case RolesArcgisActionTypes.LOAD_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null
      };
    }
    case RolesArcgisActionTypes.LOAD_SUCCESS: {
      return rolesArcgisAdapter.addMany(action.payload.items, {
        ...state,
        isLoading: false,
        error: null
      });
    }
    case RolesArcgisActionTypes.LOAD_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    // default
    default: {
      return state;
    }
  }
}
